import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views mantencion 
const Dashboard = () => import('@/views/Dashboard')
const Error = () => import('@/views/Error')
const Procesos = () => import('@/views/mantencion-de-actividades/Procesos')
const Configuracion = () => import('@/views/mantencion-de-actividades/Configuracion')
const Resultados = () => import('@/views/mantencion-de-actividades/Resultados')
const Liquidadores = () => import('@/views/mantencion-de-liquidadores/Liquidadores')
const RegistroRubro = () => import('@/views/mantencion/registro-rubro')
const CtaCteBeneficiario = () => import('@/views/mantencion/ctactebeneficiario')
const Criterios = () => import('@/views/mantencion/Criterios')

// Views Indemnizaciones
const InformeNóminadePagos = () => import('@/views/indemnizaciones/informe-nomina-de-pagos')
const PendientesDeAprobacion = () => import('@/views/indemnizaciones/pendientes-de-aprobacion')
const EstadoDeAutorizaciones = () => import('@/views/indemnizaciones/estado-de-autorizaciones')
const ValidacionGerentedelArea = () => import('@/views/indemnizaciones/validacion-gerente-del-area')
const Indemnizaciones = () => import('@/views/indemnizaciones/Indemnizaciones')
const Transferencias = () => import('@/views/indemnizaciones/transferencias')

// Views Devoluciones
const RecuperosPorDevolver = () => import('@/views/devoluciones/recuperos-por-devolver')
const VBGerenteDevoluciones = () => import('@/views/devoluciones/vb-gerente-devoluciones')
const Devoluciones = () => import('@/views/devoluciones/Devoluciones')
const TransferenciasDev = () => import('@/views/devoluciones/transferencias')

// Views Base de Datos
const ContactosPoliza = () => import('@/views/basedatos/contactos-poliza')
const ContactosCorredor = () => import('@/views/basedatos/contactos-corredor')
const AsignarContactosCorredor = () => import('@/views/basedatos/asignar-contactos-corredor')

// Views informes
const AvisosImpagoEjecutivo = () => import('@/views/informes-siniestros/AvisosImpagoEjecutivo')
const TiemposPromedioGestion = () => import('@/views/informes-siniestros/TiemposPromedioGestion')
const CasosActivosSinCobradorLiquidadorEjecutivo = () => import('@/views/informes-siniestros/CasosActivosSinCobradorLiquidadorEjecutivo')
const TareasActividades = () => import('@/views/informes-siniestros/TareasActividades')
const CasosAsignadosaLiquidadorsinInformedeLiquidacion = () => import('@/views/informes-siniestros/CasosAsignadosaLiquidadorsinInformedeLiquidacion')
const CargaDeTrabajoCantidadDePagoPorEjecutivo = () => import('@/views/informes-siniestros/CargaDeTrabajoCantidadDePagoPorEjecutivo')
const CasosYPolizas = () => import('@/views/informes-siniestros/CasosYPolizas')
const RegistroDeLosMailsDeDobroDirecto = () => import('@/views/informes-siniestros/RegistroDeLosMailsDeDobroDirecto')
const CasosActivosConInformeDeLiquidación = () => import('@/views/informes-siniestros/CasosActivosConInformeDeLiquidación')
const ActividadesPorPeriodo = () => import('@/views/informes-siniestros/ActividadesPorPeriodo')
const ConsolidadoIndemnizaciones = () => import('@/views/informes-siniestros/ConsolidadoIndemnizaciones')
const ControlGestion = () => import('@/views/informes-siniestros/ControlGestion')

// Views Garantia
const InformeNominaPagos = () => import('@/views/garantia/informe-nomina-pagos')
const ValidacionGerenteArea = () => import('@/views/garantia/validacion-gerente-area')
const GarIndemnizaciones = () => import('@/views/garantia/Indemnizaciones')
const GarTransferencias = () => import('@/views/garantia/transferencias')
const GarCtaCteBeneficiarios = () => import('@/views/garantia/ctactebeneficiario')
const GarRegCorrespondencia = () => import('@/views/garantia/regcorrespondencia')
const GarCrearSiniestro = () => import('@/views/garantia/crearSiniestro')
const GarAsigLiqCob = () => import('@/views/garantia/asigLiqCob')
const GarCrearTarea = () => import('@/views/garantia/crearTarea')
const GarProvision = () => import('@/views/garantia/provision')
const GarSeguimiento = () => import('@/views/garantia/seguimiento')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/inicio',
      name: 'Inicio',
      component: DefaultContainer,
      children: [
        {
          path: '403',
          name: 'Error',
          component: Error,
        },
        {
          path: 'inicio',
          name: 'Inicio',
          //component: Dashboard
        },
        {
          path: '/mantencion-de-actividades',
          redirect: '/mantencion-de-actividades/procesos',
          name: 'Tareas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'procesos',
            name: 'Listado',
            component: Procesos,

          }
          ]
        },
        {
          path: '/mantencion-de-actividades',
          redirect: '/mantencion-de-actividades/configuracion',
          name: 'Tareas',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'configuracion',
            name: 'Configuración',
            component: Configuracion,

          }
          ]
        },
        {
          path: '/mantencion-de-actividades',
          redirect: '/mantencion-de-actividades/resultados',
          name: 'Tareas  / Actividades',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'resultados',
            name: 'Configuración',
            component: Resultados,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/avisos-de-impago-x-ejecutivo',
          name: 'Avisos de Impago x Ejecutivo',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'avisos-de-impago-x-ejecutivo',
            name: 'Avisos de Impago x Ejecutivo',
            component: AvisosImpagoEjecutivo,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/tiempos-promedio-de-gestion',
          name: 'Tiempos Promedio de Gestión',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'tiempos-promedio-de-gestion',
            name: 'Tiempos Promedio de Gestión',
            component: TiemposPromedioGestion,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Casos-activos-sin-cobrador-liquidador-por-ejecutivo',
          name: 'Casos Act. sin Cob/Liq. x Ejec.',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Casos-activos-sin-cobrador-liquidador-por-ejecutivo',
            name: 'Casos Act. sin Cob/Liq. x Ejec.',
            component: CasosActivosSinCobradorLiquidadorEjecutivo,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Tareas-Actividades',
          name: 'Tareas y Actividades',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Tareas-Actividades',
            name: 'Tareas y Actividades',
            component: TareasActividades,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Casos-Asignados-a-Liquidador-sin-Informe-de-Liquidacion',
          name: 'Asig liq sin inf de liquidación',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Casos-Asignados-a-Liquidador-sin-Informe-de-Liquidacion',
            name: 'Asig liq sin inf de liquidación',
            component: CasosAsignadosaLiquidadorsinInformedeLiquidacion,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Carga-de-trabajo-cantidad-de-pagos-por-ejecutivo',
          name: 'Asig liq sin inf de liquidación',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Carga-de-trabajo-cantidad-de-pagos-por-ejecutivo',
            name: 'Carga de trabajo cantidad de pagos por ejecutivo',
            component: CargaDeTrabajoCantidadDePagoPorEjecutivo,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/casos-y-polizas',
          name: 'Siniestros por Póliza',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Casos-y-Polizas',
            name: 'Siniestros por Póliza',
            component: CasosYPolizas,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Registro-de-los-mails-de-cobro-directo',
          name: 'Siniestros en cobranza directa',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Registro-de-los-mails-de-cobro-directo',
            name: 'Siniestros en cobranza directa',
            component: RegistroDeLosMailsDeDobroDirecto,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Casos-activos-con-informe-de-liquidación',
          name: 'Casos activos con informe de liquidación',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Casos-activos-con-informe-de-liquidación',
            name: 'Casos activos con informe de liquidación',
            component: CasosActivosConInformeDeLiquidación,

          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/actividades-por-periodo',
          name: 'Actividades por periodo',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'actividades-por-periodo',
            name: 'Actividades por periodo',
            component: ActividadesPorPeriodo,

          }
          ]
        },
        {
          path: '/mantencion-de-liquidadores',
          redirect: '/mantencion-de-liquidadores/liquidadores',
          name: 'Liquidadores',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'liquidadores',
            name: 'Liquidadores',
            component: Liquidadores,

          }
          ]
        },//ConsolidadoIndemnizaciones
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/Consolidado-Indemnizaciones',
          name: 'Consolidado Indemnizaciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Consolidado-Indemnizaciones',
            name: 'Consolidado Indemnizaciones',
            component: ConsolidadoIndemnizaciones
          }
          ]
        },
        {
          path: '/informes-siniestros',
          redirect: '/informes-siniestros/control-de-gestion',
          name: 'Control de Gestión',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'control-de-gestion',
            name: 'Control de Gestión',
            component: ControlGestion
          }
          ]
        },
        {
          path: '/mantencion',
          redirect: '/mantencion/registro-rubro',
          name: 'Registro Rubro',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'registro-rubro',
            name: 'Registro Rubro',
            component: RegistroRubro,
          }
          ]
        },
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/Informe-Nómina-de-Pagos',
          name: 'Informe Nómina de Pagos',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Informe-Nómina-de-Pagos',
            name: 'Informe Nómina de Pagos',
            component: InformeNóminadePagos,
          }
          ]
        },
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/Pendientes-de-Aprobación',
          name: 'Pendientes de Aprobación',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Pendientes-de-Aprobación',
            name: 'Pendientes de Aprobación',
            component: PendientesDeAprobacion,
          }
          ]
        }, 
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/estado-de-autorizaciones',
          name: 'Estado de Autorizaciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'estado-de-autorizaciones',
            name: 'Estado de Autorizaciones',
            component: EstadoDeAutorizaciones,
          }
          ]
        },
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/Validación-Gerente-del-Area',
          name: 'Validación Gerente del Area',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Validación-Gerente-del-Area',
            name: 'Validación Gerente del Area',
            component: ValidacionGerentedelArea,
          }
          ]
        },
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/Indemnizaciones',
          name: 'Indemnizaciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Indemnizaciones',
            name: 'Indemnizaciones',
            component: Indemnizaciones,
          }
          ]
        },
        {
          path: '/mantencion',
          redirect: '/mantencion/Cta-Cte-Beneficiarios',
          name: 'Cta Cte Beneficiarios',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Cta-Cte-Beneficiarios',
            name: 'Cta Cte Beneficiarios',
            component: CtaCteBeneficiario,
          }
          ]
        },
        {
          path: '/mantencion',
          redirect: '/mantencion/Criterios',
          name: 'Criterios',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Criterios',
            name: 'Criterios',
            component: Criterios,
          }
          ]
        },
        {
          path: '/indemnizaciones',
          redirect: '/indemnizaciones/Transferencias',
          name: 'Transferencias',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Transferencias',
            name: 'Transferencias',
            component: Transferencias,
          }
          ]
        },
        {
          path: '/devoluciones',
          redirect: '/devoluciones/Recuperos-por-Devolver',
          name: 'Recuperos por Devolver',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Recuperos-por-Devolver',
            name: 'Recuperos por Devolver',
            component: RecuperosPorDevolver,
          }
          ]
        },
        {
          path: '/devoluciones',
          redirect: '/devoluciones/VB-Gerente-Devoluciones',
          name: 'VB Gerente Devoluciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'VB-Gerente-Devoluciones',
            name: 'VB Gerente Devoluciones',
            component: VBGerenteDevoluciones,
          }
          ]
        },
        {
          path: '/devoluciones',
          redirect: '/devoluciones/Devoluciones',
          name: 'Devoluciones',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Devoluciones',
            name: 'Devoluciones',
            component: Devoluciones,
          }
          ]
        },
        {
          path: '/devoluciones',
          redirect: '/devoluciones/Transferencias',
          name: 'Transferencias',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Transferencias',
            name: 'Transferencias',
            component: TransferenciasDev,
          }
          ]
        },

        // Base de Datos
      {
        path: '/basedatos',
        redirect: '/basedatos/contactos-poliza',
        name: 'Contatos póliza',
        component: {
          render(c) { return c('router-view') }
        },
        children: [{
          path: 'contactos-poliza',
          name: 'contactos-poliza',
          component: ContactosPoliza,
        }
        ]
      },
      {
        path: '/basedatos',
        redirect: '/basedatos/contactos-corredor',
        name: 'Contactos corredor',
        component: {
          render(c) { return c('router-view') } 
          },
          children: [{path: 'contactos-corredor',
                      name: 'contactos-corredor',
                      component: ContactosCorredor,
                    }
                  ]
        },
        {
          path: '/basedatos',
          redirect: '/basedatos/asignar-contactos-corredor',
          name: 'Asignar Contactos corredor',
          component: {
          render(c) { return c('router-view') } 
          },
          children: [{path: 'asignar-contactos-corredor',
                      name: 'asignar-contactos-corredor',
                      component: AsignarContactosCorredor,
                     }
                    ]
        },

        // Garantía
        {
          path: '/garantia',
          redirect: '/garantia/InformeNominaPagos',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'InformeNominaPagos',
            name: 'Informe Nómina de Pagos',
            component: InformeNominaPagos,
          }
          ]
        },
        {
          path: '/garantia',
          redirect: '/garantia/VBGerente',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'VBGerente',
            name: 'Validación Gerente del Area',
            component: ValidacionGerenteArea,
          }
          ]
        }, 
        {
          path: '/garantia',
          redirect: '/garantia/Indemnizaciones',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Indemnizaciones',
            name: 'Indemnizaciones',
            component: GarIndemnizaciones,
          }
          ]
        }, 
        {
          path: '/garantia',
          redirect: '/garantia/Transferencias',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Transferencias',
            name: 'Transferencias',
            component: GarTransferencias,
          }
          ]
        }, 
        {
          path: '/garantia',
          redirect: '/garantia/Cta-Cte-Beneficiarios',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Cta-Cte-Beneficiarios',
            name: 'Cta Cte Beneficiarios',
            component: GarCtaCteBeneficiarios,
          }
          ]
        },
		    {
          path: '/garantia',
          redirect: '/garantia/RegCorrespondencia',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'RegCorrespondencia',
            name: 'Registro de Correspondencia',
            component: GarRegCorrespondencia,
          }
          ]
        },
        {
          path: '/garantia',
          redirect: '/garantia/CrearSiniestro',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'CrearSiniestro',
            name: 'Crear Siniestro',
            component: GarCrearSiniestro,
          }
          ]
        },
		    {
          path: '/garantia',
          redirect: '/garantia/AsigLiquidador',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'AsigLiquidador',
            name: 'Asignar Liquidador Cobrador',
            component: GarAsigLiqCob,
          }
          ]
        },
		    {
          path: '/garantia',
          redirect: '/garantia/CrearTarea',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'CrearTarea',
            name: 'Crear Tarea',
            component: GarCrearTarea,
          }
          ]
        },
        {
          path: '/garantia',
          redirect: '/garantia/Provision',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'Provision',
            name: 'Provisión',
            component: GarProvision,
          }
          ]
        },
        {
          path: '/garantia',
          redirect: '/garantia/seguimiento',
          name: 'Garantía',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'seguimientosiniestro',
            name: 'Seguimiento de Siniestro',
            component: GarSeguimiento,
          }
          ]
        },

      ]
    }
  ]
})
